export function stripUnhelpfulCitations(text: string): string {
  // Remove OpenAI citation artefacts that sometimes leak into markdown:
  // - bracketed markers like: [citeturn0search0], [citeturn0news13], [cite[turn0search0|turn0search1]]
  // - private-use “cite” glyph sequences like: citeturn0news13
  // Keep markdown whitespace/newlines intact (do NOT collapse whitespace).

  if (!text) return ''

  return (
    text
      // [cite[...]] and other bracketed cite blocks
      .replace(/\[cite\[[^\]]*\]\]/g, '')
      .replace(/\[cite[^\]]*\]/g, '')
      // [citeturn0news13] / [citeturn0search0]
      .replace(/\[citeturn[^\]]+\]/gi, '')
      // bare citeturn0news13 tokens
      .replace(/citeturn\d+(?:news|search)\d+/gi, '')
      // private-use glyph sequences (best-effort, non-greedy)
      .replace(/cite.*?/g, '')
      // block-character "cite" markers sometimes appear like: █cite█turn0search16█
      .replace(/[▁-█]*cite[▁-█]*turn\d+(?:news|search)\d+[▁-█]*/gi, '')
      // bare turn0search12 / turn0news3 tokens
      .replace(/turn\d+(?:news|search)\d+/gi, '')
      // any remaining private-use glyphs (commonly used by citation markers)
      .replace(/[\uE000-\uF8FF]/g, '')
      .trim()
  )
}

export function linkifyPlainUrls(text: string): string {
  if (!text) return ''

  const urlRegex = /(https?:\/\/[^\s<>()]+[^\s<>().,;:!?])/g

  return text.replace(urlRegex, (raw) => {
    // If it already looks like part of a markdown link destination, leave it alone.
    // (Best-effort; avoids mangling `](https://...)`.)
    const idx = text.indexOf(raw)
    if (idx > 1 && text.slice(Math.max(0, idx - 2), idx) === '](') return raw

    try {
      const u = new URL(raw)
      const label = u.hostname.replace(/^www\./, '')
      return `[${label}](${raw})`
    } catch {
      return raw
    }
  })
}

export function urlHostname(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '')
  } catch {
    return url
  }
}


